"use strict";
// like typesafe-actions
Object.defineProperty(exports, "__esModule", { value: true });
exports.isOfActions = exports.isOfAction = exports.createMapAction = exports.createEmptyMapAction = exports.createEmptyAction = exports.createAction = void 0;
function createAction(type, map) {
    var actionCreator = map;
    actionCreator.type = type;
    return actionCreator;
}
exports.createAction = createAction;
function createEmptyAction(type) {
    return createAction(type, function () { return ({ type: type }); });
}
exports.createEmptyAction = createEmptyAction;
function createEmptyMapAction(type, payloadCreator) {
    return createAction(type, function () { return ({ type: type, payload: payloadCreator() }); });
}
exports.createEmptyMapAction = createEmptyMapAction;
function createMapAction(type, payloadCreator) {
    return createAction(type, function (a) { return ({ type: type, payload: payloadCreator(a) }); });
}
exports.createMapAction = createMapAction;
function isOfAction(ofActionCreator) {
    var type = ofActionCreator.type;
    return function (action) { return action.type === type; };
}
exports.isOfAction = isOfAction;
// implementation
function isOfActions(ofActionCreators) {
    return function (action) {
        return ofActionCreators.some(function (_a) {
            var type = _a.type;
            return action.type === type;
        });
    };
}
exports.isOfActions = isOfActions;
